import { Component, Input } from '@angular/core';

@Component({
    selector: 'csi-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: false
})
export class LoadingComponent {
  @Input() isLoading = true;
  constructor() { }
}
